// removed by extract-text-webpack-plugin
module.exports = {"glossary":"AttributeGlossary__glossary___2OHV8","itemList":"AttributeGlossary__itemList___3IlBy","itemColumn":"AttributeGlossary__itemColumn___3_vvb","glossaryItem":"AttributeGlossary__glossaryItem___3NwK9","attribute":"AttributeGlossary__attribute___3F5BS","definition":"AttributeGlossary__definition___3Iu4S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AttributeGlossary/AttributeGlossary.less
// module id = 1217
// module chunks = 0